import * as React from 'react'
import { Tooltip as AntTooltip, App } from 'antd'

export function TooltipProvider({
  children,
  delayDuration: _d,
}: {
  children: React.ReactNode
  delayDuration?: number
}) {
  return <App>{children}</App>
}

export const Tooltip = AntTooltip

export function TooltipTrigger({
  children,
  asChild: _a,
}: {
  children: React.ReactNode
  asChild?: boolean
}) {
  return <>{children}</>
}
TooltipTrigger.displayName = 'TooltipTrigger'

export function TooltipContent({
  children,
  className,
  sideOffset: _s,
}: {
  children: React.ReactNode
  className?: string
  sideOffset?: number
}) {
  return <span className={className}>{children}</span>
}
TooltipContent.displayName = 'TooltipContent'
